import React, { useEffect, useRef } from 'react';
import { getSuggestionsTrackingData } from 'Components/widgets/alternative-proposals/AlternativeProposalsUtils';
import { useAppContext } from 'Context/ReactAppContext';
import { t } from 'Src/i18n';
import type { TrackingPayload } from 'Tracking/tracking-api/useTracking';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import { SidePanel } from 'Components/frameworks/side-panel/SidePanel';
import type { AlternativeProposalsProps } from 'Components/widgets/alternative-proposals/AlternativeProposals';
import { AlternativeProposals } from 'Components/widgets/alternative-proposals/AlternativeProposals';
type Props = AlternativeProposalsProps & {
  onClose: () => void;
  trackingDefaultPayload: TrackingPayload;
};
export const AlternativeProposalsModal = ({ trackingDefaultPayload, ...props }: Props) => {
  const appContext = useAppContext();
  const modal = useRef();
  const track = useTracking(trackingDefaultPayload);
  const proposal = props.proposals[0];
  useEffect(() => {
    const trackingData = getSuggestionsTrackingData({
      appContext,
      disableAlternativePrice: props.disableAlternativePrice,
      proposal,
      suggestions: props.suggestions,
    });
    track(trackingData);
  }, [proposal]);
  return (
    <SidePanel
      aria-label={t('booking.counterProposalPopIn.rateCounterProposalTitle')}
      closeLabel={t('common.close')}
      isExpanded
      onClose={(event) => {
        if (modal.current && !modal.current.contains(event.target)) {
          props.onClose();
          track({
            labelGA: 'exit',
          });
        }
      }}
    >
      <div ref={modal}>
        <AlternativeProposals {...props} />
      </div>
    </SidePanel>
  );
};
